import ProductItem from '../components/product/ProductItem';
import initCarousel from '../helpers/carousel';

const selectors = {
  mainCarousel: '[flickity-slider-carousel]',
  productItem: '[data-product-item]',
  prevBtn: '[data-carousel-prev-btn]',
  nextBtn: '[data-carousel-next-btn]',
};

export default class DynamicProductSelector {
  constructor(section) {
    // Init product items
    const productItems = section.el.querySelectorAll(selectors.productItem);
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });

    initCarousel(section.el, selectors);
  }
}
